import { render, staticRenderFns } from "./FacturasSimpleTable.vue?vue&type=template&id=333aab80&scoped=true"
import script from "./FacturasSimpleTable.vue?vue&type=script&lang=js"
export * from "./FacturasSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333aab80",
  null
  
)

export default component.exports